import { render, staticRenderFns } from "./basePagination.vue?vue&type=template&id=c73e73dc&scoped=true&"
import script from "./basePagination.vue?vue&type=script&lang=js&"
export * from "./basePagination.vue?vue&type=script&lang=js&"
import style0 from "./basePagination.vue?vue&type=style&index=0&id=c73e73dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73e73dc",
  null
  
)

export default component.exports